module.exports = __webpack_public_path__ + "img/home_pic2.da2faa14.png";